<template>
  <div>
    <div class="form-group">
      <label for="coupon">Coupon Codes (Optional)</label>
      <input
        v-model="text"
        :disabled="disabled"
        type="text"
        class="form-control"
        id="coupon"
        name="coupon"
        @blur="onBlur"
        @keypress.enter="onEnter"
      />
    </div>

    <div class="d-flex flex-wrap">
      <coupon-badge v-for="coupon in value" :key="coupon" @remove="onRemove(coupon)" class="mr-2 mb-3">
        {{ coupon }}
      </coupon-badge>
    </div>
  </div>
</template>

<script>
import AttestationsForm from './AttestationsForm';
import CouponBadge from './CouponBadge.vue';
import CreditCardForm from './CreditCardForm';
import SignatureForm from './SignatureForm';

export default {
  name: 'coupons-form',
  components: {AttestationsForm, CouponBadge, CreditCardForm, SignatureForm},
  props: {
    disabled: {
      type: Boolean,
    },
    value: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      text: '',
    };
  },
  methods: {
    onBlur() {
      this.processText(this.text);
    },
    onEnter() {
      this.processText(this.text);
    },
    onRemove(coupon) {
      const coupons = this.value.filter(c => c !== coupon);
      this.$emit('input', coupons);
    },
    processText(text) {
      const addedCoupons = text
        .split(',')
        .map(coupon => coupon.trim())
        .filter(coupon => coupon && !this.value.includes(coupon));

      if (addedCoupons.length) {
        const coupons = this.value.concat(...addedCoupons);
        this.$emit('input', coupons);
      }

      this.text = '';
    },
  },
};
</script>

<style lang="scss" scoped></style>
